import {post} from '@/utils/request';
import {erpserver,erpplatserver,oaserver,sse_url} from '@/utils/baseUrl';

//列表
export async function getKhlistWithNoRights(params) {
    return post(erpserver+'/currency/getKhlistWithNoRights', params, true);
}
//公司
export async function getCompanyList(params) {
    return post(erpserver+'/currency/getCompanyList', params, true);
}
//汇率
export async function getbzlist(params) {
    return post(erpserver+'/currency/getbzlist', params, true);
}

//列表
export async function withInvoiceServer(params) {
    return post(erpserver+'/invoiceInterface/withInvoiceServer', params, true);
}
//进项发票作废
export async function disableInvoice(params) {
    return post(erpserver+'/purchaseinvoice/disableInvoice', params, true);
}